import React, { FC, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import styles from "./index.module.scss";
import { useAsyncEffect, useInfiniteScroll } from "ahooks";
import { postOrderList } from "@/pages/Order/api";
import { HeaderWithLogin } from "@/modules/login/ui";
import Dialog from "@/pages/Order/components/Dialog";
import config from "@/config";
import OrderItem from "@/pages/Order/components/OrderItem";
import Empty from "@/pages/Order/components/Empty";
import { GalleryItemType } from "@/stores/gallery";
import { langStore } from "@noli/business";
import { orderLangRecords } from "@/pages/Order/lang";

export interface OrderItemType {
  order_id: string;
  name: string;
  price: string;
  active_price: string;
  product_type: "wenxin" | "accelerator";
  pay_time: number;
  order_state_id: 3;
}
export interface OrderDataType {
  page_index: number;
  page_size: number;
  order_list: OrderItemType[];
  total: number;
}
const Order: FC<any> = (props) => {
  const lang = langStore.tgt;
  const orderListRef = useRef<HTMLDivElement | null>(null);
  const [orderData, setOrderData] = useState<OrderDataType>({
    page_index: 0,
    page_size: 10,
    order_list: [],
    total: 0,
  });
  const [customerServiceDialogVisible, setCustomerServiceDialogVisible] = useState<boolean>(false);
  const onLoadMore: any = (targetPageIndex?: number) => {
    return new Promise((resolve) => {
      postOrderList({
        page_index: targetPageIndex ?? orderData.page_index,
        page_size: orderData.page_size,
      }).then((res) => {
        setOrderData({
          page_index: res.data.page_index,
          page_size: res.data.page_size,
          order_list: [...orderData.order_list, ...res.data.order_list],
          total: res.data.total,
        });
        resolve({
          list: res.data.order_list,
          total: res.data.total,
        });
      });
    });
  };

  const { noMore, reload } = useInfiniteScroll((d) => onLoadMore(orderData.page_index + 1), {
    target: orderListRef,
    isNoMore: (d?: { list: GalleryItemType[]; total: any }) => {
      console.log(orderData, 1111111);
      return orderData.order_list.length >= orderData.total && d?.total;
    },
    manual: true,
    threshold: 500,
  });
  useAsyncEffect(async () => {
    await reload();
  }, []);
  return (
    <>
      <div className={styles.orderWrapper}>
        <HeaderWithLogin />
        <div className={styles.orderContent}>
          <div className={styles.titleWrapper}>
            <h2>{orderLangRecords[lang]["MyOrder"]}</h2>
            <span className={styles.tip}>
              {orderLangRecords[lang]["Questions"]}{" "}
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  setCustomerServiceDialogVisible(true);
                }}
              >
                {orderLangRecords[lang]["ContactCustomer"]}
              </span>
            </span>
          </div>
          {orderData.total ? (
            <OrderItem data={orderData.order_list} refs={orderListRef} total={orderData.total} />
          ) : (
            <Empty />
          )}
        </div>
      </div>
      <Dialog
        visible={customerServiceDialogVisible}
        onClose={() => {
          setCustomerServiceDialogVisible(false);
        }}
      >
        <p className={styles.wechatServiceTitle}>{orderLangRecords[lang]["ScanCode"]}</p>
        <img
          src={`${config.buildCdnBaseUrl}assets/creator/wechatService.png`}
          alt=""
          className={styles.wechatService}
        />
        <p className={styles.serviceTip}>{orderLangRecords[lang]["PleaseNote"]}</p>
      </Dialog>
    </>
  );
};
export default observer(Order);
